import StoreDetailedReport from "./StoreDetailedReport";

const Invoice: React.FC = () => {
  return <StoreDetailedReport />;
};

export default Invoice;
